module.exports = __webpack_public_path__ + "static/icon/tripwise-icon-outline/iconfont.eot";